import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Página Não Encontrada | CSSBuy Spreadsheet";
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => {
      const existing = document.head.querySelector('meta[name="robots"][content="noindex, nofollow"]');
      if (existing) existing.remove();
    };
  }, []);

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-6">
          <i className="ri-error-warning-line text-2xl text-primary-600"></i>
        </div>
        <h1 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mb-3">
          Página Não Encontrada
        </h1>
        <p className="text-sm text-foreground-400 font-mono mb-6">{location.pathname}</p>
        <p className="text-sm text-foreground-600 max-w-md mx-auto mb-8 leading-relaxed">
          A página que você procura não existe ou foi movida. Confira nossos guias e planilhas para continuar economizando nas compras da China.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            onClick={() => navigate("/")}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-line"></i> Voltar ao Início
          </button>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-100 text-foreground-700 text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
          >
            Acessar CSSBuy <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </div>
  );
}